import axios from 'axios';

const API_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:3001';

export interface StoreProduct {
  id: string;
  name: string;
  description?: string;
  price: number;
  stock?: number;
  category?: string;
  featured: boolean;
  images: {
    id: string;
    url: string;
    isPrimary: boolean;
    order: number;
  }[];
}

export interface StoreProductsResponse {
  data: StoreProduct[];
  meta: {
    total: number;
    page: number;
    limit: number;
    totalPages: number;
  };
}

export interface CreateOrderData {
  customerName: string;
  customerEmail: string;
  customerPhone: string;
  customerDocument?: string;
  zipCode: string;
  address: string;
  number: string;
  complement?: string;
  neighborhood: string;
  city: string;
  state: string;
  items: {
    productId: string;
    quantity: number;
  }[];
  paymentMethod?: string;
  notes?: string;
  isAdminOrder?: boolean; // Permite criar pedido com produtos fora da loja (venda interna/admin)
}

export interface Order {
  id: string;
  orderNumber: string;
  customerName: string;
  customerEmail: string;
  customerPhone: string;
  zipCode: string;
  address: string;
  number: string;
  complement?: string;
  neighborhood: string;
  city: string;
  state: string;
  subtotal: number;
  shipping: number;
  total: number;
  status: string;
  paymentMethod?: string;
  paymentStatus: string;
  notes?: string;
  createdAt: string;
  items: {
    id: string;
    productId: string;
    productName: string;
    price: number;
    quantity: number;
    subtotal: number;
    product: StoreProduct;
  }[];
}

export const storeService = {
  async getProducts(params?: {
    search?: string;
    category?: string;
    minPrice?: number;
    maxPrice?: number;
    page?: number;
    limit?: number;
  }): Promise<StoreProductsResponse> {
    const response = await axios.get(`${API_URL}/products/store/list`, { params });
    return response.data;
  },

  async getProduct(id: string): Promise<StoreProduct> {
    const response = await axios.get(`${API_URL}/products/store/${id}`);
    return response.data;
  },

  async createOrder(data: CreateOrderData): Promise<Order> {
    const response = await axios.post(`${API_URL}/orders`, data);
    return response.data;
  },

  async getOrderByNumber(orderNumber: string): Promise<Order> {
    const response = await axios.get(`${API_URL}/orders/number/${orderNumber}`);
    return response.data;
  },
};
